import React, { FC } from 'react';
import { Colors, FontWeights } from 'core/CssVariables';
import { Icon } from '../../../Icon';
import { TIconNames } from '../../../Icon/Icon.type';
import { Text } from '../../../Typography';
import { TTextEmailProps } from '../EditableEmail.type';

const TextEmail: FC<TTextEmailProps> = ({
  setIsEditable,
  fontWeight,
  fontLevel,
  email,
}) => {
  const onHandleClick = () => {
    setIsEditable(true);
  };

  return (
    <Text
      className="pt-1 pb-1 pl-2"
      fontLevel={fontLevel || 5}
      fontWeight={fontWeight || FontWeights.Medium}
      onClick={onHandleClick}
      editable={{
        icon: (
          <Icon
            icon={TIconNames.EDIT}
            color={Colors.Blue}
            size={16}
            className="edit-icon ml-2"
          />
        ),
      }}
    >
      {email}
    </Text>
  );
};

export default TextEmail;
